import { MenuItem, Select, styled } from "@mui/material";

export const ClusterMenuItem = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingRight: 0,
  paddingLeft: 0,
  alignItems: "center",
  gap: theme.spacing(2),
  alignSelf: "stretch",
  borderBottom: `1px solid ${theme.palette.grey?.[600]}`,
  fontSize: theme.spacing(2.5),
  lineHeight: theme.spacing(2.625),
  letterSpacing: "0.5px",
  fontWeight: 500,
  "&:first-child": {
    paddingTop: 0
  },
  "&.Mui-selected": {
    color: theme.palette.primary?.main,
    background: "none!important",
    fontWeight: 700,
    "&:hover": {
      background: "none"
    }
  },
  "&:hover": {
    background: "none"
  }
}));

export const ClusterSelect = styled(Select)(({ theme }) => ({
  borderColor: theme.palette.common?.white,
  background: theme.linearGradients.gradientB,
  "&.MuiInputBase-root": {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: theme.spacing(2.5),
    fontWeight: 700,
    lineHeight: theme.spacing(2.625),
    letterSpacing: "0.5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: theme.spacing(0.5),
    borderColor: theme.palette.common?.white
  },
  "&.Mui-focused" : {
    borderColor: theme.palette.common?.white
  },
  ".MuiSelect-select": {
    padding: 0,
    display: "flex",
    alignItems: "center",
    height: theme.spacing(5)
  },
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.common?.white
  },
  ".MuiSelect-iconOpen": {
    transform: "rotate(180deg)"
  },
  ".MuiSelect-icon": {
    transition:"all .3s linear"
  },
  ".MuiMenu-list": {
    marginTop: theme.spacing(1)
  }
}));
